import * as React from "react";
import type { SVGProps } from "react";
const Restaurant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_4009)">
      <g clipPath="url(#clip1_4362_4009)">
        <path
          fill="currentColor"
          d="M22.2857-1.7139c-.8571 0-6.8571 1.7143-6.8571 9.4286v6c0 1.8911 1.5375 3.4286 3.4285 3.4286h1.7143v6.8571c0 .9482.7661 1.7143 1.7143 1.7143S24 24.9486 24 24.0004v-24c0-.9482-.7661-1.7143-1.7143-1.7143M3.4286-.8567c0-.4393-.3268-.8036-.7661-.8518s-.8304.241-.9268.6643L.1125 6.2576A4.7 4.7 0 0 0 0 7.2808c0 2.4589 1.8804 4.4785 4.2857 4.6982v12.0214c0 .9482.766 1.7143 1.7143 1.7143s1.7143-.7661 1.7143-1.7143V11.979C10.1196 11.7593 12 9.7397 12 7.2808a4.7 4.7 0 0 0-.1125-1.0232l-1.6232-7.3018a.857.857 0 0 0-.9322-.6643.854.854 0 0 0-.7607.8518v7.1893a.526.526 0 0 1-.525.525c-.2732 0-.4982-.209-.525-.4822L6.8518-.9317A.8524.8524 0 0 0 6-1.714a.8524.8524 0 0 0-.8518.7822L4.484 6.3754c-.0268.2732-.2518.4822-.525.4822a.526.526 0 0 1-.525-.525zM6.016 7.286h-.032L6 7.2486z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4362_4009">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4362_4009">
        <path fill="transparent" d="M0-1.7139h24v27.4286H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Restaurant;
